import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-br from-[#1a1a1a] to-[#2d2d2d] text-white py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_793a21d1-f278-4746-b089-be151b084274/artifacts/gzv2mp07_LogoMauma.png"
              alt="MAUMA"
              className="w-40 mb-4 brightness-200"
            />
            <p className="text-gray-400 text-sm">
              Beauty House - Head Spa<br />
              Carrasco, Montevideo
            </p>
          </div>

          <div>
            <h3 className="text-lg font-medium mb-4 text-[#C9A86A]">
              Formas de Pago
            </h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>• Transferencia bancaria (BROU)</li>
              <li>• Mercado Pago</li>
              <li>• Efectivo</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-medium mb-4 text-[#C9A86A]">
              Contacto
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Manuel Otero 6313, Carrasco<br />
              Montevideo, Uruguay
            </p>
            <div className="flex gap-4">
              <motion.a
                href="https://www.instagram.com/mauma.uy/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#C9A86A] rounded-full flex items-center justify-center"
                whileHover={{ scale: 1.1, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </motion.a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; 2025 MAUMA Beauty House. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;